import React from 'react'
import classNames from 'classnames/bind'

import Spacer from 'components/ui/Spacer'

import s from './HorizontalWrapper.module.scss'
const cn = classNames.bind(s)

const HorizontalWapper = ({ children, className = '' }) => {
  return (
    <div className={cn('wrapper', className)}>
      <Spacer initial="6rem" medium="11.11vh" horizontal />
      {children}
      <Spacer initial="6rem" medium="11.11vh" horizontal />
    </div>
  )
}

export default HorizontalWapper
